import React from 'react';
import { Checkbox } from 'pvs-design-system';
import { Box } from '@mui/material';
import type { Role } from 'types';

interface RoleCheckboxListProps {
  roles: Role[];
  selectedRoleIds: Set<number>;
  onToggle: (id: number) => void;
}

/**
 * Memoized grid of role checkboxes for the Create/Edit Resource admin forms.
 *
 * Isolated behind React.memo so typing in the Name / URL / Description fields
 * does not re-render this (often 50+ item) list. It only re-renders when the
 * `roles` data or the `selectedRoleIds` selection actually change. The parent
 * must pass a stable `onToggle` (useCallback) for the memoization to hold.
 */
const RoleCheckboxList: React.FC<RoleCheckboxListProps> = ({ roles, selectedRoleIds, onToggle }) => (
  <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px 16px' }}>
    {roles.map((role) => (
      <Checkbox
        key={role.id}
        id={`role-${role.id}`}
        label={role.name}
        checked={selectedRoleIds.has(role.id)}
        onChange={() => onToggle(role.id)}
      />
    ))}
  </Box>
);

export default React.memo(RoleCheckboxList);
